import css from 'styled-jsx/css'
import { colors, fontSizes, fontWeights, measurements } from 'theme'

export default css`
.card-container {
  background-color: ${colors.lightGray};
  margin: 0.5rem 0;
  padding: 1.5rem 0;
  border-radius: ${measurements.borderRadius};
  height: 15rem;
}
.card-container.low {
  background-color: ${colors.alpha(colors.dangerLow, 0.1)};
  border-left: 10px solid ${colors.dangerLow};
}
.card-container.medium {
  background-color: ${colors.alpha(colors.warningLow, 0.1)};
  border-left: 10px solid ${colors.warningLow};
}
.card-container.high {
  background-color: ${colors.alpha(colors.primary, 0.1)};
  border-left: 10px solid ${colors.primary};
}
.card-score {
  display: flex;
  justify-content: center;
}
.score {
  margin-left: 1rem;
}
.score__title{
  display: block;
  font-size: ${fontSizes.p};
}
.score__score {
  font-size: ${fontSizes.h1};
  font-weight: ${fontWeights.semiBold};
}
.score__info {
  margin-left: 0.5rem;
}
.card-recommendation {
  font-size: ${fontSizes.tiny};
}
.card-recommendation__title {
  font-size: inherit;
}
.card-recommention__info {
  font-size: inherit;
  font-weight: ${fontWeights.semiBold};
  margin: 0 1rem;
}
.card-recommention__info:first-child{
  margin-top: 1rem;
}
.card-buttons {
  margin-top: 1.5rem;
}
.card-icons {
  margin-top: 1rem;
}
.card-icon {
  margin-left: 2rem;
}
.card-icon:first-child {
  margin: 0;
}

`